"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  addStorefrontWidgetAction,
  removeStorefrontWidgetAction,
} from "@/server-actions/shopify/storefront-widget"
import { storefrontWidgetQueryKeyPrefix } from "@/hooks/queries/shopify-storefront-widget"
import { withQueryHandling } from "@/lib/with-query-handling"

export function useAddStorefrontWidgetMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: { channelId: string; integrationId: string }) => {
      // The add dialog shows the result.
      const result = await withQueryHandling(addStorefrontWidgetAction(input), {
        showLoadingToast: false,
        showSuccessToast: false,
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    // Every widget's view of a store changes when one widget takes it over.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: storefrontWidgetQueryKeyPrefix }),
  })
}

export function useRemoveStorefrontWidgetMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: { integrationId: string }) => {
      const result = await withQueryHandling(removeStorefrontWidgetAction(input), {
        loading: "Removing the widget from your store...",
        success: "Widget removed from your store",
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: storefrontWidgetQueryKeyPrefix }),
  })
}
